import LogoWithCoreLevel from './LogoWithCoreLevel';
import LogoWithCoreLevelContainer from './LogoWithCoreLevel.container';
export default LogoWithCoreLevelContainer(LogoWithCoreLevel);
